export const downloadFile = (base64: string, fileName: string) => {
  // Convert base64 to raw binary data held in a string
  const byteString = atob(base64.split(',')[1]);

  // Separate out the mime component
  const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];

  // Write the bytes of the string to an ArrayBuffer
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  // Create a blob from the Uint8Array
  const blob = new Blob([uint8Array], { type: mimeString });

  // Create an anchor element and trigger a download
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);

  // Append to html link element page
  document.body.appendChild(link);

  // Start download
  link.click();

  // Clean up and remove the link
  link.parentNode.removeChild(link);
};
